import { render, staticRenderFns } from "./GuestBox.vue?vue&type=template&id=34e6defc&scoped=true&"
import script from "./GuestBox.vue?vue&type=script&lang=js&"
export * from "./GuestBox.vue?vue&type=script&lang=js&"
import style0 from "./GuestBox.vue?vue&type=style&index=0&id=34e6defc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34e6defc",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('34e6defc')) {
      api.createRecord('34e6defc', component.options)
    } else {
      api.reload('34e6defc', component.options)
    }
    module.hot.accept("./GuestBox.vue?vue&type=template&id=34e6defc&scoped=true&", function () {
      api.rerender('34e6defc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2U8q6LTOagjIH/JS/comp/GuestBox.vue"
export default component.exports